import React, { useEffect, useState } from 'react';
import Modal, { ModalProps } from 'react-bootstrap/Modal';
import ActionButton from 'src/components/visionx/buttons/ActionButton';
import { ElementWithTooltip } from 'src/components/common/vx/element-with-tooltip/ElementWithTooltip';
import './ElementWithModal.css';
import ActionBtnV2 from 'src/components/visionx/buttons/ActionBtnV2';

export type ElementWithModalDO = {
  element: React.JSX.Element;
  modalContent: React.JSX.Element;
  header?: string | React.JSX.Element;
  size?: ModalProps['size'];
  fullscreen?: ModalProps['fullscreen'];
  withCancel?: boolean;
  withCloseButton?: boolean | undefined;
  centered?: boolean | undefined;
  backdropClassName?: string | undefined;
  close?: boolean;
  open?: boolean;
  refresher?: string;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  onCloseHandler?: Function;
  withReload?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  withCancelYesHandler?: Function | undefined;
  headerBorder?: boolean | undefined;
  withHeader?: boolean | undefined;
  extraHeaderClass?: string;
};
export default function ElementWithModal({
  element,
  modalContent,
  header,
  size,
  fullscreen,
  withCloseButton = true,
  withCancel,
  close,
  open,
  refresher,
  onCloseHandler,
  withReload,
  withCancelYesHandler,
  headerBorder = true,
  backdropClassName,
  withHeader = true,
  backdrop = true,
  extraHeaderClass = '',
  dialogClassName,
  contentClassName,
  centered = false,
}: ElementWithModalDO & ModalProps) {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    if (onCloseHandler) {
      onCloseHandler();
    }
  };
  const handleShow = () => setShow(true);

  useEffect(() => {
    if (close) handleClose();
  }, [close, refresher]);
  useEffect(() => {
    if (open) {
      handleShow();
    } else {
      handleClose();
    }
  }, [open]);

  function CloseBtn() {
    return (
      <ElementWithTooltip
        element={
          <div className={''}>
            <ActionBtnV2
              cy={'close-modal-btn'}
              iconClass={'fa-solid fa-xmark'}
              onClick={handleClose}
            />
          </div>
        }
        tooltip={<span>Close</span>}
      />
    );
  }

  return (
    <>
      <span
        role={'button'}
        data-bs-toggle="modal"
        data-bs-target={'#modal'}
        onClick={handleShow}
      >
        {element}
      </span>

      <Modal
        backdropClassName={backdropClassName ? backdropClassName : 'modal-backdrop'}
        show={show}
        centered={centered}
        onHide={handleClose}
        size={size ? size : 'lg'}
        fullscreen={fullscreen}
        scrollable
        backdrop={backdrop}
        dialogClassName={dialogClassName}
        contentClassName={['vx-modal-content', contentClassName].filter(Boolean).join(' ')}
      >
        {' '}
        {!withHeader && withCloseButton && (
          <div className={'d-flex justify-content-end m-2'}>
            <CloseBtn />
          </div>
        )}
        {withHeader && (
          <Modal.Header
            className={
              `w-100 modal-header-border d-flex align-items-start justify-content-between ${extraHeaderClass}  ` +
              (headerBorder ? '' : 'border-0')
            }
          >
            <div className={'w-100 '}>{header}</div>

            {withCloseButton && (
              <div>
                <CloseBtn />
              </div>
            )}
          </Modal.Header>
        )}
        <Modal.Body>{modalContent}</Modal.Body>
        {withCancel && (
          <Modal.Footer className={'d-flex justify-content-center border-0 gap-2'}>
            <ActionButton
              type="destructive-ghost"
              action={'cancel'}
              icon={'fa-solid fa-xmark'}
              label={'Cancel'}
              onClick={() => {
                setShow(false);
              }}
            />

            {withCancelYesHandler && (
              <ActionButton
                type="primary"
                action={'save'}
                icon={'fa-solid fa-check'}
                label={'Yes'}
                onClick={() => {
                  withCancelYesHandler();
                }}
              />
            )}
          </Modal.Footer>
        )}
        {withReload && (
          <Modal.Footer className={'d-flex justify-content-center border-0'}>
            <ActionButton
              action={'refresh'}
              label={'Retry'}
              onClick={() => {
                setShow(false);
                window.location.reload();
              }}
            />
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
}
